import type {
  CreateCharge,
  CreateTask,
  UpdateCharge,
  UpdateQuote,
  UpdateTask,
} from "@common/client"

export type TaskFields = Omit<UpdateTask, "operation" | "id">
export type ChargeFields = Omit<UpdateCharge, "operation" | "id">
export type NewChargeFields = Omit<CreateCharge, "operation">
export type NewTaskFields = Omit<CreateTask, "operation">

export function addTask(fields: NewTaskFields): UpdateQuote {
  return { tasks: [{ operation: "create", ...fields }] }
}

export function addTaskFromTemplate(templateId: string): UpdateQuote {
  return {
    tasks: [
      { operation: "create_from_template", canned_work_task_id: templateId },
    ],
  }
}

export function applyTemplate(taskId: string, templateId: string): UpdateQuote {
  return {
    tasks: [
      {
        operation: "apply_template",
        id: taskId,
        canned_work_task_id: templateId,
      },
    ],
  }
}

export function underTask(taskId: string, fields: TaskFields): UpdateQuote {
  return { tasks: [{ operation: "update", id: taskId, ...fields }] }
}

export function acrossTasks(
  taskIds: string[],
  fields: TaskFields,
): UpdateQuote {
  return {
    tasks: taskIds.map((id) => ({ operation: "update", id, ...fields })),
  }
}

export function underCharge(
  taskId: string,
  chargeId: string,
  fields: ChargeFields,
): UpdateQuote {
  return underTask(taskId, {
    charges: [{ operation: "update", id: chargeId, ...fields }],
  })
}

export function addCharge(
  taskId: string,
  fields: NewChargeFields,
): UpdateQuote {
  return underTask(taskId, { charges: [{ operation: "create", ...fields }] })
}

export function removeCharge(taskId: string, chargeId: string): UpdateQuote {
  return underTask(taskId, {
    charges: [{ operation: "remove", id: chargeId }],
  })
}
